export enum Integration {
    GLSM = 'glsm',
    MARI_APPS = 'mariApps',
    ONE_PORT = 'onePort',
    CLOUD_FLEET_MANAGER = 'cloudFleetManager',
    BASS_NET = 'bassNet',
}
